<app-register-account-pannel
  title="New Development Partner Account"
  url="devt-partners"
></app-register-account-pannel>
